export default "/_next/static/images/c22828c8ead71508afc65122c3a5fa66.jpg";